import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { usePermissionStore } from '^/store/permissionStore';
import SearchIcon from '^/assets/icons/search.svg';
import dsPalette from '^/constants/ds-palette';
import { UseL10n, useL10n } from '^/hooks';
import CloseSvg from '^/assets/icons/close.svg';

import text from './text';
import theme from '^/theme';

const Wrapper = styled.div<{ size: MemberSearchInputProps['size']; isActive: boolean }>(
  ({ size, isActive }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '48px',
    minHeight: '29px',
    width: size === 'md' ? '284px' : '351px',
    padding: '0 10px',
    background: isActive ? theme.colors.white[10] : theme.colorTokens.bgWhiteDark,
    borderWidth: size === 'md' ? '1px' : '2px',
    borderStyle: 'solid',
    borderColor: isActive ? theme.colorTokens.accentBlue : theme.colorTokens.lineCool,
    boxSizing: 'border-box',
    borderRadius: '8px',
    fontSize: size === 'md' ? '11px' : '13px',
    ':hover': {
      background: theme.colors.white[10],
    },
  })
);

const Input = styled.input({
  flexGrow: 1,
  marginLeft: '5px',
  backgroundColor: 'transparent',

  color: dsPalette.typePrimary.toString(),
  fontSize: 'inherit',
  '&::placeholder': {
    color: '#c7c7c7',
    opacity: 1,
  },
});

const ClearButton = styled.button({
  marginLeft: '5px',
  width: '16px',
  height: '16px',

  backgroundColor: 'transparent',
  cursor: 'pointer',
  fontWeight: 500,
  color: dsPalette.themePrimary.toString(),

  fontSize: 'inherit',
});

const CloseIcon = styled(CloseSvg)({
  fill: theme.colors.neutralGray[700],
});

const SVGWrapper = styled.svg({});

interface MemberSearchInputProps {
  size?: 'md' | 'lg';
}
export const MemberSearchInput: FC<MemberSearchInputProps> = ({ size = 'md' }) => {
  const setSearchText = usePermissionStore(s => s.setSearchText);
  const searchText = usePermissionStore(s => s.searchText);
  const [l10n]: UseL10n = useL10n();
  const [isActive, setIsActive] = useState(false);
  const handleSearchchange = (e: any) => {
    setSearchText(e.target.value);
  };
  const handleClearClick = () => {
    setSearchText('');
  };

  return (
    <Wrapper size={size} isActive={isActive}>
      <SVGWrapper width={17} height={17}>
        <SearchIcon />
      </SVGWrapper>
      <Input
        placeholder={l10n(text.placeholderText)}
        onChange={handleSearchchange}
        value={searchText}
        onFocus={() => setIsActive(true)}
        onBlur={() => setIsActive(false)}
      />
      {searchText && (
        <ClearButton onClick={handleClearClick}>
          <CloseIcon />
        </ClearButton>
      )}
    </Wrapper>
  );
};
